import React from "react";
// import office2 from "assets/img/examples/office2.jpg";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// import classNames from "classnames";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
// sections of this Page
// import Button from "components/CustomButtons/Button.js";
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
// import Card from "components/Card/Card.js";
// import CardBody from "components/Card/CardBody.js";
// import CustomInput from "components/CustomInput/CustomInput.js";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import FormControl from "@material-ui/core/FormControl";
// import InputLabel from "@material-ui/core/InputLabel";
// import Radio from "@material-ui/core/Radio";
// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
// import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
// import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
// import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { post } from "../../lib/requests";
// import {
// 	LoadingMgs,
// 	SuccessMessage,
// 	ErrorMessage,
// } from "components/Common/toastify";

// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as Yup from "yup";
// const useStyles2 = makeStyles(headersStyle);
// const useStyles3 = makeStyles(basicsStyle);

import sectionsPageStyle from "assets/jss/material-kit-pro-react/views/sectionsPageStyle.js";
import Kinetix from "components/ManualOrder/Kinetix";

const useStyles = makeStyles(sectionsPageStyle);

// const BandWidth = [
// 	"Bundle 25/10",
// 	"Bundle 50/20",
// 	"Home Fast Bundle 100/20",
// 	"Bundle 100/40",
// 	"Home Superfast Bundle 250/25",
// 	"Bundle 250/100",
// 	"Home Ultrafast Bundle 1000/50",
// 	"Business Bundle 100/100",
// 	"Bundle 500/200",
// 	"Business Bundle 200/200",
// 	"Bundle 1000/400",
// 	"Business Bundle 400/400",
// ];

// const Size = [
// 	"Enterprise",
// 	"Government",
// 	"Medium",
// 	"Small",
// 	"Micro",
// 	"Wholesale",
// ];

// const ServiceType = [
// 	"Layer 3 - IPoE (Standard)",
// 	"Layer 3 - PPPoE (Mapped)",
// 	"Layer 3 - PPPoE (AnyPass)",
// 	"Layer 3 - PPPoE (Tagged)",
// ];

// const RestorationSLA = [
// 	"Standard",
// 	"Small Business - Enhanced 12 (24/7)",
// 	"Small Business - Enhanced 4 (24/7)",
// ];

export default function ManualOrderPage() {
	const classes = useStyles();
	// const classes2 = useStyles2();
	// const classes3 = useStyles3();
	// const [size, setSize] = useState("");
	// const [serviceType, setServiceType] = useState("");
	// const [bandwidth, setBandwidth] = useState("");

	// const [loading, setLoading] = useState(false);

	// const [typeCheckbox, setTypeCheckbox] = useState("");
	// const [upgradeCheckbox, setUpgradeCheckbox] = useState("");
	// const [restorationCheckbox, setRestorationCheckbox] = useState("");
	// const [batteryCheckbox, setBatteryCheckbox] = useState("");
	// const [IPv4Checkbox, setIPv4Checkbox] = useState("");

	// form validation rules
	// const validationSchema = Yup.object().shape({
	// 	// Site Address
	// 	SiteAddress: Yup.string().required("Site Address is required"),
	// 	// Location ID
	// 	LocationID: Yup.string().required("Location ID is required"),
	// 	Type: Yup.string().required("Type is required"),
	// 	// fiber upgrade
	// 	FiberUpgrade: Yup.string().required("Fiber Upgrade is required"),
	// 	// Company Name
	// 	CompanyName: Yup.string().required("Company Name is required"),
	// 	// Trading Name
	// 	TradingName: Yup.string().required("Trading Name is required"),
	// 	// ABN/ACN
	// 	ABNACN: Yup.string().required("ABN/ACN is required"),
	// 	// Parent Entity
	// 	ParentEntity: Yup.string().required("Parent Entity is required"),
	// 	// Contact Name
	// 	ContactName: Yup.string().required("Contact Name is required"),

	// 	// Phone Number
	// 	PhoneNumber: Yup.string().required("Phone Number is required"),
	// 	// Email
	// 	Email: Yup.string().required("Email is required"),
	// 	// Size
	// 	Size: Yup.string().required("Size is required"),
	// 	// Service Type
	// 	ServiceType: Yup.string().required("Service Type is required"),
	// 	// Bandwidth
	// 	Bandwidth: Yup.string().required("Bandwidth is required"),
	// 	// Restoration SLA
	// 	RestorationSLA: Yup.string().required("Restoration SLA is required"),
	// 	// Informed consent to this order without a battery backup service
	// 	BatteryBackupService: Yup.string().required(
	// 		"Informed consent to this order without a battery backup service is required"
	// 	),
	// 	// IPv4
	// 	IPv4: Yup.string().required("IPv4 is required"),
	// 	// Submission
	// 	Submission: Yup.string().required("Submission is required"),
	// });
	// const formOptions = { resolver: yupResolver(validationSchema) };

	// // get functions to build form with useForm() hook
	// const {
	// 	register,
	// 	handleSubmit,
	// 	setError,
	// 	setValue,
	// 	reset,
	// 	formState,
	// } = useForm(formOptions);
	// const { errors } = formState;

	// async function onSubmit(formField) {
	// 	console.log("formField", formField);
	// 	return;
	// 	setLoading(true);
	// 	LoadingMgs("Login", "processing...");

	// 	try {
	// 		await post("/api/login", formField)
	// 			.then((res) => {
	// 				if (res.data.success) {
	// 					SuccessMessage("Login", "Login success");
	// 					reset();
	// 				} else {
	// 					ErrorMessage("Login", res.data.message);
	// 				}
	// 				setLoading(false);
	// 			})
	// 			.catch((error) => {
	// 				let message = "";
	// 				if (error.response?.data.message) {
	// 					message = error.response?.data.message;
	// 				} else {
	// 					message = error?.message;
	// 				}
	// 				ErrorMessage("Login", message);
	// 				setLoading(false);
	// 			});
	// 	} catch (error) {
	// 		console.log("error", error);
	// 		ErrorMessage("Login", "Something went wrong try again!!");
	// 		setLoading(false);
	// 	}
	// }

	// const handleSize = (event) => {
	// 	setSize(event.target.value);
	// };

	// const handleServiceType = (event) => {
	// 	setServiceType(event.target.value);
	// };

	// const handleBandwidth = (event) => {
	// 	setBandwidth(event.target.value);
	// };

	return (
		<div>
			<Header
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>
			<div className={classes.main}>
				<Kinetix />
				{/* <div
					className={classes2.pageHeader}
					style={{
						backgroundImage: `url("${office2}")`,
					}}>
					<div className={classes2.conatinerHeader2}>
						<GridContainer>
							<GridItem
								xs={12}
								sm={10}
								md={10}
								className={classNames(
									classes2.mlAuto,
									classes2.mrAuto,
									classes2.textCenter
								)}>
								<h1 className={classes2.title}>
									Auscomp Cloud Service Order - Kinetix
								</h1>
								<h6 className={classes2.subTitle}>
									<span className="text-red-600 mr-2">* </span>
									Required
								</h6>
							</GridItem>
							<GridItem
								xs={12}
								sm={10}
								md={10}
								className={classNames(classes2.mlAuto, classes2.mrAuto)}>
								<Card raised className={classes2.card}>
									<CardBody formHorizontal>
										<form onSubmit={handleSubmit(onSubmit)}>
											<GridContainer>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle)}>
														1. Site Address <span className="text-red-600 mr-2"> * </span>
													</div>
													<CustomInput
														inputProps={{
															placeholder: "Enter your answer here",
															...register("SiteAddress"),
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.SiteAddress?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle)}>
														2. Location ID # <span className="text-red-600 mr-2">* </span>
													</div>
													<CustomInput
														inputProps={{
															placeholder: "Enter your answer here",
															...register("LocationID"),
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.LocationID?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle, " mb-2")}>
														3. Type <span className="text-red-600 mr-2">* </span>
													</div>
													<div
														className={
															classes3.checkboxAndRadio +
															" " +
															classes3.checkboxAndRadioHorizontal
														}>
														<FormControlLabel
															control={
																<Radio
																	checked={typeCheckbox === "Business"}
																	onChange={() => setTypeCheckbox("Business")}
																	value="Business"
																	name="radio button enabled"
																	aria-label="Business"
																	icon={
																		<FiberManualRecord className={classes3.radioUnchecked} />
																	}
																	checkedIcon={
																		<FiberManualRecord className={classes3.radioChecked} />
																	}
																	classes={{
																		checked: classes3.radio,
																		root: classes3.radioRoot,
																	}}
																/>
															}
															classes={{
																label: classes3.label,
																root: classes3.labelRoot,
															}}
															label="Business"
														/>
													</div>
													<div
														className={
															classes3.checkboxAndRadio +
															" " +
															classes3.checkboxAndRadioHorizontal
														}>
														<FormControlLabel
															control={
																<Radio
																	checked={typeCheckbox === "Home"}
																	onChange={() => setTypeCheckbox("Home")}
																	value="Home"
																	name="radio button enabled"
																	aria-label="Home"
																	icon={
																		<FiberManualRecord className={classes3.radioUnchecked} />
																	}
																	checkedIcon={
																		<FiberManualRecord className={classes3.radioChecked} />
																	}
																	classes={{
																		checked: classes3.radio,
																		root: classes3.radioRoot,
																	}}
																/>
															}
															classes={{
																label: classes3.label,
																root: classes3.labelRoot,
															}}
															label="Home"
														/>
													</div>
													<input type="hidden" {...register("Type")} value={typeCheckbox} />
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.Type?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle, " mb-2")}>
														4. Does this require a fiber upgrade?{" "}
														<span className="text-red-600 mr-2">* </span>
													</div>
													<div
														className={
															classes3.checkboxAndRadio +
															" " +
															classes3.checkboxAndRadioHorizontal
														}>
														<FormControlLabel
															control={
																<Radio
																	checked={upgradeCheckbox === "Yes"}
																	onChange={() => setUpgradeCheckbox("Yes")}
																	value="Yes"
																	name="radio button enabled"
																	aria-label="Yes"
																	icon={
																		<FiberManualRecord className={classes3.radioUnchecked} />
																	}
																	checkedIcon={
																		<FiberManualRecord className={classes3.radioChecked} />
																	}
																	classes={{
																		checked: classes3.radio,
																		root: classes3.radioRoot,
																	}}
																/>
															}
															classes={{
																label: classes3.label,
																root: classes3.labelRoot,
															}}
															label="Yes"
														/>
													</div>
													<div
														className={
															classes3.checkboxAndRadio +
															" " +
															classes3.checkboxAndRadioHorizontal
														}>
														<FormControlLabel
															control={
																<Radio
																	checked={upgradeCheckbox === "No"}
																	onChange={() => setUpgradeCheckbox("No")}
																	value="No"
																	name="radio button enabled"
																	aria-label="No"
																	icon={
																		<FiberManualRecord className={classes3.radioUnchecked} />
																	}
																	checkedIcon={
																		<FiberManualRecord className={classes3.radioChecked} />
																	}
																	classes={{
																		checked: classes3.radio,
																		root: classes3.radioRoot,
																	}}
																/>
															}
															classes={{
																label: classes3.label,
																root: classes3.labelRoot,
															}}
															label="No"
														/>
													</div>
													<input
														type="hidden"
														{...register("FiberUpgrade")}
														value={upgradeCheckbox}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.FiberUpgrade?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle, " mb-2")}>
														5. Company Name <span className="text-red-600 mr-2">* </span>
													</div>
													<CustomInput
														id="billing_frequency"
														inputProps={{
															placeholder: "Enter your answer here",
															...register("CompanyName"),
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.CompanyName?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle, " mb-2")}>
														6. Trading Name <span className="text-red-600 mr-2">* </span>
													</div>
													<CustomInput
														id="billing_frequency"
														inputProps={{
															placeholder: "Enter your answer here",
															...register("TradingName"),
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.TradingName?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle)}>
														7. ABN/ACN
														<span className="text-red-600 mr-2"> * </span>
													</div>
													<CustomInput
														id="subscription_end_date"
														inputProps={{
															placeholder: "Enter your answer here",
															...register("ABNACN"),
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.ABNACN?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle)}>
														8. Parent Entity
														<span className="text-red-600 mr-2"> * </span>
													</div>
													<CustomInput
														id="auscomp_account_number"
														inputProps={{
															placeholder: "Enter your answer here",
															...register("ParentEntity"),
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.ParentEntity?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle)}>
														9. Contact Name <span className="text-red-600 mr-2">* </span>
													</div>
													<CustomInput
														inputProps={{
															placeholder: "Enter your answer here",
															...register("ContactName"),
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.ContactName?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle)}>
														10. Phone Number <span className="text-red-600 mr-2">* </span>
													</div>
													<CustomInput
														inputProps={{
															placeholder: "Enter your answer here",
															...register("PhoneNumber"),
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.PhoneNumber?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle)}>
														11. Email <span className="text-red-600 mr-2">* </span>
													</div>
													<CustomInput
														inputProps={{
															placeholder: "Enter your answer here",
															...register("Email"),
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.Email?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle)}>
														12. Size <span className="text-red-600 mr-2">* </span>
													</div>
													<FormControl fullWidth className={classes3.selectFormControl}>
														<InputLabel
															htmlFor="simple-select"
															className={classes3.selectLabel}>
															Select Size
														</InputLabel>
														<Select
															MenuProps={{
																className: classes3.selectMenu,
															}}
															classes={{
																select: classes3.select,
															}}
															value={size}
															onChange={handleSize}
															inputProps={{
																id: "size",
																...register("Size"),
															}}>
															{Size.map((item, index) => (
																<MenuItem
																	key={index}
																	classes={{
																		root: classes3.selectMenuItem,
																		selected: classes3.selectMenuItemSelected,
																	}}
																	value={item}>
																	{item}
																</MenuItem>
															))}
														</Select>
													</FormControl>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.Size?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle, "mt-2 mb-2")}>
														13. Service Type <span className="text-red-600 mr-2">* </span>
													</div>
													<FormControl fullWidth className={classes3.selectFormControl}>
														<InputLabel
															htmlFor="simple-select"
															className={classes3.selectLabel}>
															Select Service Type
														</InputLabel>
														<Select
															MenuProps={{
																className: classes3.selectMenu,
															}}
															classes={{
																select: classes3.select,
															}}
															value={serviceType}
															onChange={handleServiceType}
															inputProps={{
																id: "serviceType",
																...register("ServiceType"),
															}}>
															{ServiceType.map((item, index) => (
																<MenuItem
																	key={index}
																	classes={{
																		root: classes3.selectMenuItem,
																		selected: classes3.selectMenuItemSelected,
																	}}
																	value={item}>
																	{item}
																</MenuItem>
															))}
														</Select>
													</FormControl>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.ServiceType?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle, "mt-2 mb-2")}>
														14. Bandwidth <span className="text-red-600 mr-2">* </span>
													</div>

													<FormControl fullWidth className={classes3.selectFormControl}>
														<InputLabel
															htmlFor="simple-select"
															className={classes3.selectLabel}>
															Select Bandwidth
														</InputLabel>
														<Select
															MenuProps={{
																className: classes3.selectMenu,
															}}
															classes={{
																select: classes3.select,
															}}
															value={bandwidth}
															onChange={handleBandwidth}
															inputProps={{
																id: "bandwidth",
																...register("Bandwidth"),
															}}>
															{BandWidth.map((item, index) => (
																<MenuItem
																	key={index}
																	classes={{
																		root: classes3.selectMenuItem,
																		selected: classes3.selectMenuItemSelected,
																	}}
																	value={item}>
																	{item}
																</MenuItem>
															))}
														</Select>
													</FormControl>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.Bandwidth?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle, "mt-2 mb-2")}>
														15. Restoration SLA
														<span className="text-red-600 mr-2"> * </span>
													</div>
													{RestorationSLA.map((item) => (
														<div
															key={item}
															className={
																classes3.checkboxAndRadio +
																" " +
																classes3.checkboxAndRadioHorizontal
															}>
															<FormControlLabel
																control={
																	<Radio
																		checked={restorationCheckbox == item}
																		onChange={() => setRestorationCheckbox(item)}
																		value={item}
																		name="radio button enabled"
																		aria-label={item}
																		icon={
																			<FiberManualRecord className={classes3.radioUnchecked} />
																		}
																		checkedIcon={
																			<FiberManualRecord className={classes3.radioChecked} />
																		}
																		classes={{
																			checked: classes3.radio,
																			root: classes3.radioRoot,
																		}}
																	/>
																}
																classes={{
																	label: classes3.label,
																	root: classes3.labelRoot,
																}}
																label={item}
															/>
														</div>
													))}
													<input
														type="hidden"
														{...register("RestorationSLA")}
														value={restorationCheckbox}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.RestorationSLA?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle, " mb-2")}>
														16. Informed consent to this order without a battery backup
														service <span className="text-red-600 mr-2">* </span>
													</div>
													<div
														className={
															classes3.checkboxAndRadio +
															" " +
															classes3.checkboxAndRadioHorizontal
														}>
														<FormControlLabel
															control={
																<Radio
																	checked={batteryCheckbox === "Static"}
																	onChange={() => setBatteryCheckbox("Static")}
																	value="Static"
																	name="radio button enabled"
																	aria-label="Static"
																	icon={
																		<FiberManualRecord className={classes3.radioUnchecked} />
																	}
																	checkedIcon={
																		<FiberManualRecord className={classes3.radioChecked} />
																	}
																	classes={{
																		checked: classes3.radio,
																		root: classes3.radioRoot,
																	}}
																/>
															}
															classes={{
																label: classes3.label,
																root: classes3.labelRoot,
															}}
															label="Static"
														/>
													</div>
													<div
														className={
															classes3.checkboxAndRadio +
															" " +
															classes3.checkboxAndRadioHorizontal
														}>
														<FormControlLabel
															control={
																<Radio
																	checked={batteryCheckbox === "Dynamic"}
																	onChange={() => setBatteryCheckbox("Dynamic")}
																	value="Dynamic"
																	name="radio button enabled"
																	aria-label="Dynamic"
																	icon={
																		<FiberManualRecord className={classes3.radioUnchecked} />
																	}
																	checkedIcon={
																		<FiberManualRecord className={classes3.radioChecked} />
																	}
																	classes={{
																		checked: classes3.radio,
																		root: classes3.radioRoot,
																	}}
																/>
															}
															classes={{
																label: classes3.label,
																root: classes3.labelRoot,
															}}
															label="Dynamic"
														/>
													</div>
													<input
														type="hidden"
														{...register("BatteryBackupService")}
														value={batteryCheckbox}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.BatteryBackupService?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle, " mb-2")}>
														17. IPv4 <span className="text-red-600 mr-2">* </span>
													</div>
													<div className="mb-2 text-small">
														Defaults to a 'Dynamic' address. Changing to 'Fixed' may incur a
														fee.
													</div>
													<div
														className={
															classes3.checkboxAndRadio +
															" " +
															classes3.checkboxAndRadioHorizontal
														}>
														<FormControlLabel
															control={
																<Radio
																	checked={IPv4Checkbox === "Yes"}
																	onChange={() => setIPv4Checkbox("Yes")}
																	value="Yes"
																	name="radio button enabled"
																	aria-label="Yes"
																	icon={
																		<FiberManualRecord className={classes3.radioUnchecked} />
																	}
																	checkedIcon={
																		<FiberManualRecord className={classes3.radioChecked} />
																	}
																	classes={{
																		checked: classes3.radio,
																		root: classes3.radioRoot,
																	}}
																/>
															}
															classes={{
																label: classes3.label,
																root: classes3.labelRoot,
															}}
															label="Yes"
														/>
													</div>
													<div
														className={
															classes3.checkboxAndRadio +
															" " +
															classes3.checkboxAndRadioHorizontal
														}>
														<FormControlLabel
															control={
																<Radio
																	checked={IPv4Checkbox === "No"}
																	onChange={() => setIPv4Checkbox("No")}
																	value="No"
																	name="radio button enabled"
																	aria-label="No"
																	icon={
																		<FiberManualRecord className={classes3.radioUnchecked} />
																	}
																	checkedIcon={
																		<FiberManualRecord className={classes3.radioChecked} />
																	}
																	classes={{
																		checked: classes3.radio,
																		root: classes3.radioRoot,
																	}}
																/>
															}
															classes={{
																label: classes3.label,
																root: classes3.labelRoot,
															}}
															label="No"
														/>
													</div>
													<input type="hidden" {...register("IPv4")} value={IPv4Checkbox} />
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.IPv4?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
													<div className={classNames(classes2.labelTitle)}>
														18. Submission
														<span className="text-red-600 mr-2"> * </span>
													</div>
													<CustomInput
														id="submission"
														inputProps={{
															placeholder: "Enter your answer here",
															type: "date",
															...register("Submission"),
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl + " " + classes2.placeHolderCss,
														}}
													/>
													<div className="text-red-600 text-xs ml-3 pt-1">
														{errors.Submission?.message}
													</div>
												</GridItem>
												<GridItem xs={12} sm={3} md={3} className={classes2.customInput}>
													<Button
														block
														color="info"
														className={classes2.button}
														type="submit"
														disabled={formState.isSubmitting}>
														Submit
													</Button>
												</GridItem>
											</GridContainer>
										</form>
									</CardBody>
								</Card>
							</GridItem>
						</GridContainer>
					</div>
				</div> */}
			</div>
		</div>
	);
}
